<template>
  <v-col class="extraction-field-multiple-select pt-4">
    <v-checkbox
      v-for="(option, idx) in options"
      :key="`${option}-${idx}`"
      v-model="selectedOptions"
      class="ma-0 mb-2 pt-0"
      hide-details
      :disabled="disabled"
      :label="option"
      :value="option"
      @change="emitInput"
    >
      <template #label>
        <span
          class="grey--text text--darken-2 text-body-2 font-weight-light"
        >
          {{ option }}
        </span>
      </template>
    </v-checkbox>
    <v-checkbox
      v-if="allowOther"
      v-model="otherSelected"
      class="ma-0"
      hide-details
      :disabled="disabled"
      label="Other"
      @change="emitInput"
    >
      <template #label>
        <span
          class="grey--text text--darken-2 text-body-2 font-weight-light"
        >
          Other
        </span>
      </template>
    </v-checkbox>
    <v-text-field
      v-if="allowOther"
      v-model="otherText"
      hide-details="auto"
      single-line
      :placeholder="label"
      class="flex-grow-1 text-body-2"
      :disabled="disabled || !otherSelected"
      @change="emitInput"
    />
  </v-col>
</template>

<script>
import { typeHelpers } from '@/modules';

export default {
  name: 'ExtractionFieldMultipleSelect',
  props: {
    value: {
      type: Array,
      default: () => [],
      validator: (val) => typeHelpers.isArrayOfType(val, 'string'),
    },
    label: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      required: true,
      validator: (val) => typeHelpers.isArrayOfType(val, 'string'),
    },
    allowOther: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  data: () => ({
    otherSelected: false,
    otherText: '',
    selectedOptions: [],
  }),
  created() {
    const selectedOptions = [];
    if (this.value) {
      for (const selection of this.value) {
        if (this.options.includes(selection)) {
          selectedOptions.push(selection);
        } else if (this.allowOther) {
          this.otherSelected = true;
          this.otherText = selection;
        }
      }
    }
    this.selectedOptions = selectedOptions;
  },
  methods: {
    emitInput() {
      const value = [...this.selectedOptions];
      if (this.otherSelected && this.otherText) {
        value.push(this.otherText);
      }
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
.extraction-field-multiple-select {
  padding: 0;
}
</style>
